import _ from 'lodash';
import { connect } from 'react-redux';
import {
	searchCustomers,
	searchTerms,
	searchVendors,
	searchClasses,
	searchAccounts,
	searchItems,
} from '../../modules/accounting/quickbooks';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	/** @namespace state.lists.quickbooksCustomerIds **/
	/** @namespace state.lists.quickbooksVendorIds **/
	/** @namespace state.lists.quickbooksClassIds **/
	/** @namespace state.lists.quickbooksAccountIds **/
	/** @namespace state.lists.quickbooksItemIds **/
	/** @namespace state.maps.quickbooksCustomer **/
	/** @namespace state.maps.quickbooksVendor **/
	/** @namespace state.maps.quickbooksClass **/
	/** @namespace state.maps.quickbooksAccount **/
	/** @namespace state.maps.quickbooksItem **/
	/** @namespace state.maps.user **/
	let quickbooksCustomers = [];
	if (state.lists.quickbooksCustomerIds) {
		quickbooksCustomers = _.map(
			state.lists.quickbooksCustomerIds,
			(id) => state.maps.quickbooksCustomer[id]
		);
	}

	let quickbooksVendors = [];
	if (state.lists.quickbooksVendorIds) {
		quickbooksVendors = _.map(
			state.lists.quickbooksVendorIds,
			(id) => state.maps.quickbooksVendor[id]
		);
	}

	let quickbooksClasses = [];
	if (state.lists.quickbooksClassIds) {
		quickbooksClasses = _.map(
			state.lists.quickbooksClassIds,
			(id) => state.maps.quickbooksClass[id]
		);
	}

	let quickbooksAccounts = [];
	if (state.lists.quickbooksAccountIds) {
		quickbooksAccounts = _.map(
			state.lists.quickbooksAccountIds,
			(id) => state.maps.quickbooksAccount[id]
		);
	}

	let quickbooksItems = [];
	if (state.lists.quickbooksItemIds) {
		quickbooksItems = _.map(state.lists.quickbooksItemIds, (id) => state.maps.quickbooksItem[id]);
	}

	let quickbooksTerms = [];
	/** @namespace state.lists.quickbooksTermIds */
	if (state.lists.quickbooksTermIds) {
		/** @namespace state.maps.quickbooksTerm */
		quickbooksTerms = _.map(state.lists.quickbooksTermIds, (id) => state.maps.quickbooksTerm[id]);
	}

	return {
		quickbooksCustomers,
		quickbooksVendors,
		quickbooksClasses,
		quickbooksAccounts,
		quickbooksItems,
		quickbooksTerms,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchQuickbooksCustomers: searchCustomers,
			searchQuickbooksTerms: searchTerms,
			searchQuickbooksVendors: searchVendors,
			searchQuickbooksClasses: searchClasses,
			searchQuickbooksAccounts: searchAccounts,
			searchQuickbooksItems: searchItems,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
